import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { dataService } from '../../../services/data.services';

export const BroadcastsList = createAsyncThunk('broadcastsSlice/BroadcastsList', async (endpoint) => {
    const res = await dataService.GetAPI(endpoint);
    return res;
});

const BroadcastsSlice = createSlice({
    name: 'broadcastsSlice',
    initialState: {
        loading: true,
        error: '',
        BroadcastsList: {},
    },
    reducers: {},
    extraReducers: {
        [BroadcastsList.pending]: (state) => {
            state.loading = true;
            state.error = null;
        },
        [BroadcastsList.fulfilled]: (state, action) => {
            state.loading = false;
            if (action?.payload?.data?.status === 200) {
                state.BroadcastsList = action.payload.data.data;
            } else {
                state.error = action?.payload?.data?.message;
            }
        },
        [BroadcastsList.rejected]: (state, { payload }) => {
            state.loading = false;
            state.error = payload?.message;
        },
    },
});

export default BroadcastsSlice.reducer;
